import { render, staticRenderFns } from "./ManageConfig.vue?vue&type=template&id=87ee76a0&"
import script from "./ManageConfig.vue?vue&type=script&lang=js&"
export * from "./ManageConfig.vue?vue&type=script&lang=js&"
import style0 from "./ManageConfig.vue?vue&type=style&index=0&id=87ee76a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports